import type { GridLayout } from '../../hooks/useGridLayout';

interface ResetGridLayoutButtonProps {
  layout: Pick<GridLayout, 'reset' | 'isCustomized'>;
}

/**
 * "Reset columns" for a grid whose layout is persisted with `useGridLayout`.
 *
 * Sits at the right end of the grid's header row, past the last column, and
 * only while a saved layout is in effect: at the defaults there is nothing to
 * undo. It is overlaid on the header rather than added as a trailing column,
 * because a real column would join the persisted column order and put an
 * empty cell on every row.
 *
 * Render it as the first child of the grid's `ag-theme-quartz` wrapper, which
 * must be `relative`; it takes the header's own background so it reads as
 * part of the header even when a wide grid's last column runs under it.
 */
export function ResetGridLayoutButton({ layout }: ResetGridLayoutButtonProps) {
  if (!layout.isCustomized) return null;
  return (
    <button
      type="button"
      onClick={layout.reset}
      className="btn btn-ghost btn-sm absolute right-3 top-1.5 z-[5] bg-surface-2"
      title="Restore the default column widths, order and pinning"
    >
      Reset columns
    </button>
  );
}
